<input #input type="text" numbersOnly [formControl]="formCtrl" *ngIf="valueType === 'repetitions'" [allowDecimals]="false" />
<me-time-input-cell [formControl]="formCtrl" *ngIf="valueType === 'interval'">
</me-time-input-cell>
